function startProcessingBtn(buttonElement: HTMLButtonElement) {
    buttonElement.setAttribute('disabled', 'disabled')
    buttonElement.innerHTML = '<span class="spinner-border spinner-border-sm"></span> ' + buttonElement.innerText
}

/**
 * @returns {*}
 */
function openAjaxModal(selector: string|HTMLElement, settings: {url: string, data: {[key: string]: {[key: string]: string}}, callback: CallableFunction, addFormData: string, refresh: boolean}) {
    let modalEl = selector
    if (typeof modalEl === "string") {
        modalEl = document.querySelector(modalEl) as HTMLElement
    }

    const modal = bootstrap.Modal.getOrCreateInstance(modalEl, {backdrop: 'static'})

    const form = modalEl.querySelector('form')

    const confirmBtn = modalEl.querySelector('[type="submit"],[data-type="submit"]')
    const handleSubmit = async (e: Event) => {
        e.preventDefault()
        modalEl.querySelectorAll('[data-bs-dismiss="modal"]').forEach((el) => el.remove())
        const data = Object.assign({}, settings.data)
        const targetEl = e.target as HTMLElement
        if (targetEl instanceof HTMLButtonElement) {
            startProcessingBtn(targetEl)
        } else if (targetEl instanceof HTMLFormElement) {
            if (settings.addFormData !== '') {
                data[settings.addFormData] = {}
                const formData = (new FormData(targetEl))
                if ('entries' in formData && typeof formData['entries'] === 'function') {
                    for (const [key, value] of formData.entries()) {
                        data[settings.addFormData][key] = value;
                    }
                }
            }
        }

        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        const response = await fetch(settings.url, {method: 'POST', body: JSON.stringify(data), headers})
        const json = await response.json();

        let hide = undefined
        if (typeof settings.callback === 'function') {
            hide = await settings.callback(json)
        }
        if (hide === undefined || hide) {
            modal.hide()
            if (settings.refresh) {
                window.location.reload()
            }
        }
    }

    if (form) {
        form.removeEventListener('submit', handleSubmit)
        form.addEventListener('submit', handleSubmit)
    } else {
        confirmBtn.removeEventListener('click', handleSubmit)
        confirmBtn.addEventListener('click', handleSubmit)
    }
    modal.show()

    return modal
}

window.openAjaxModal = openAjaxModal